/**************************************************
 * Nombre:       Blog_Imagen_Texto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Etiquetas_Autor from "./Etiquetas_Autor";
import Imagen_TextoEstilo from "./Imagen_TextoEstilo";
import Etiquetas_Relacionadas from "./Etiquetas_Relacionadas";


const Blog_Imagen_Texto = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Etiquetas_Autor item={item}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Imagen_TextoEstilo item={item}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                <Etiquetas_Relacionadas item={item}/>
            </Grid>


        </Grid>
    )

}
export default Blog_Imagen_Texto    